var _title, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLinkedin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14.38 13.8",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "linkedin")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.38,8.46V13.8H11.3v-5c0-1.25-.45-2.11-1.57-2.11A1.7,1.7,0,0,0,8.15,7.84a2.19,2.19,0,0,0-.1.76v5.2H5S5,5.36,5,4.49H8.05V5.81l0,0h0v0a3,3,0,0,1,2.78-1.54C12.85,4.27,14.38,5.6,14.38,8.46ZM3.47,1.61A1.62,1.62,0,0,1,1.72,3.22h0A1.6,1.6,0,0,1,0,1.61,1.61,1.61,0,0,1,1.74,0,1.6,1.6,0,0,1,3.47,1.61ZM.18,4.49H3.26V13.8H.18Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/linkedin.e7e6d3d2.svg";
export { ForwardRef as ReactComponent };